import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var _ = function _(t) {
    return t;
  },
  _t;
import { Palette } from "../../../constants/palettes";
import mediaQueries from "../../../util/mediaqueries";
import styled from 'styled-components';
import { backgroundColors, colors } from "../constants";
export var Container = styled.footer.withConfig({
  componentId: "sc-1evicwm-0"
})(["background:", ";color:", ";", ";"], function (props) {
  return backgroundColors[props.palette];
}, function (props) {
  return colors[props.palette];
}, mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-top: ", ";\n  "])), 0)), function (props) {
  return props.palette === Palette.Negative ? 'none' : '1px solid #e7e7e7';
}));